import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import { contentLink } from '@swf/core/utils';

import {
  TXTCLI_ADVICE_AVAILABLE_AT_Xa_hrefXXj_ELL,
  TXTCLI_BETTING_AND_GAMBLING_CAN_BE_DA_ELL
} from './RegulatoryHeaderFR.messages.json';
import styles from './RegulatoryHeaderFR.scss';
import eighteenPlusFr from './assets/eighteen-plus-fr.png';
import logoRf from './assets/logo-rf.png';

const RegulatoryHeaderFR: React.FC = () => (
  <div className={styles.regulatoryHeader}>
    <div className={styles.regulatoryText}>
      <Translation tagName="div" {...TXTCLI_BETTING_AND_GAMBLING_CAN_BE_DA_ELL} />
      <Translation
        tagName="div"
        values={{ a: contentLink }}
        {...TXTCLI_ADVICE_AVAILABLE_AT_Xa_hrefXXj_ELL}
      />
    </div>
    <div className={styles.regulatoryIcons}>
      <img width={124} height={99} className={styles.logoRf} src={logoRf} alt="" />
      <img width={40} height={40} className={styles.eighteenPlusFr} src={eighteenPlusFr} alt="" />
    </div>
  </div>
);

export default RegulatoryHeaderFR;
